"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _DownloadLink = _interopRequireDefault(require("../../DownloadLink/DownloadLink"));
var _Button = require("../../../Button/Button");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const getDateLocTime = (date_times, translate) => {
  const date = date_times.date[0];
  const formattedDate = date.split('-').reverse().join('.');
  const location = date_times?.generic_location || translate('cms.agenda.event_occurrence.unknown_location');
  const start = date_times?.start[0] || '';
  const end = date_times?.end[0] ? `- ${date_times?.end[0]}` : '';
  const time = start ? `${start} ${end} ${translate('cms.agenda.event_occurrence.hour')}` : translate('cms.agenda.event_occurrence.unknown_time');
  return `${formattedDate} / ${location} / ${time}`;
};
const Wrapper = _ref => {
  let {
    isCurrent,
    lang,
    event_occurrence_code,
    evenito_link,
    children
  } = _ref;
  return isCurrent ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      maxWidth: '100%'
    }
  }, children) : evenito_link?.url ? /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: evenito_link.url,
    style: {
      maxWidth: '100%'
    }
  }, children) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: `/${lang}/agenda/${event_occurrence_code}`,
    style: {
      maxWidth: '100%'
    }
  }, children);
};
const OccurrenceItem = _ref2 => {
  let {
    current_event_code,
    evenito_link,
    event_code,
    date_times,
    lang,
    translate
  } = _ref2;
  const isCurrent = current_event_code === event_code;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `occurrence-item sia-padding-03-top sia-padding-03-bottom sia-border-01-bottom ${isCurrent && 'no-hover'}`
  }, /*#__PURE__*/_react.default.createElement(Wrapper, {
    isCurrent: isCurrent,
    evenito_link: evenito_link,
    lang: lang,
    event_occurrence_code: event_code
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "occurrence-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-column"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "top sia-text-07",
    dangerouslySetInnerHTML: {
      __html: translate('cms.agenda.event_occurrence.kurs_code')
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "bottom sia-text-08",
    dangerouslySetInnerHTML: {
      __html: event_code
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-column"
  }, date_times.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "top sia-text-07",
    dangerouslySetInnerHTML: {
      __html: translate('cms.agenda.event_occurrence.date_loc_time')
    }
  }), date_times.length > 0 && date_times?.map(e => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "bottom sia-text-03",
    dangerouslySetInnerHTML: {
      __html: getDateLocTime(e, translate)
    }
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "info"
  }, isCurrent ? /*#__PURE__*/_react.default.createElement(_Button.Button, null, translate('cms.agenda.event_occurrence.register')) : evenito_link?.url ? /*#__PURE__*/_react.default.createElement(_DownloadLink.default, {
    text: translate('cms.agenda.event_occurrence.more_info'),
    href: evenito_link?.url,
    variant: "EXTERNAL"
  }) : /*#__PURE__*/_react.default.createElement(_DownloadLink.default, {
    text: translate('cms.agenda.event_occurrence.more_info'),
    href: `/${lang}/agenda/${event_code}`,
    variant: "INTERNAL"
  })))));
};
var _default = exports.default = OccurrenceItem;